import React from 'react'

import DynamicFeature from './DynamicFeature'
import { TFeature } from './types'

interface IDynamicFeature {
  name?: TFeature
  anyName?: TFeature[]
  everyName?: TFeature[]
}

export const WithDynamicFeature = <P extends object>(
  Component: React.ComponentType<P>,
  dynamicFeatureProps: IDynamicFeature,
) => {
  const WrappedWithDynamicFeature = (props: P) => (
    <DynamicFeature {...dynamicFeatureProps}>
      <Component {...props} />
    </DynamicFeature>
  )
  return WrappedWithDynamicFeature
}

export default WithDynamicFeature
